define('presentation/signup/presentationObjects/signupForCustomerPresentationObject',[],function() {
    return function(){
        let self = this;
        self.affiliateId = null;
        self.hubSpotContactRecordId = null;
        self.patLiveAccountNumber = null;
    };
});
